import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Tabs, Button, Layout, Spin, Modal} from "antd";
import Summary from './Summary';
import Item from './Item';
import Compare from './Compare';
import ReportHeader from '../Common/ReportHeader';
import {getFindVulnerablityStatistics} from '../Common/api';
import DownloadUrl from '../../components/DownloadUrl';
import {DownloadMd} from '../../components/DownloadPdf';
import {getPdfDownload} from '../Common/api';
import MarkdownViewer from '../../components/MarkdownViewer';

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const {Content } = Layout;
const {TabPane} = Tabs;

function ImplementReport() {
    const params = useParams();
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);

    // 변수 선언
    const reportId = params.reportId;
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');

    const reportType = 'U';  //이행진단
    const [tabId, setTabId] = useState('1');
    const [reportInfo, setReportInfo] = useState({});
    const [spinflag, setSpinflag] = useState(true);
    const [spinflagMain,  setSpinflagMain] = useState(false);
    const [markdownVisible, setMarkdownVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
            setAssetType(reportInfo.asset_type);
            setReportName(reportInfo.report_nm);
        }
    }, [reportInfo]);

    const [itemList, setItemList ] = useState([]);
    const [measureList, setMeasureList] = useState([]);
    const [assetList, setAssetList] = useState([]);
    const [compareList, setCompareList] = useState([]);
    const [assetSum, setAssetSum] = useState([]);
    const [assetList_u, setAssetListU] = useState([]);

    const [sumData, setSumData] = useState({total : 0, check : 0, Y : 0, Yed : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0});

    useEffect(() => {
        findReportList(reportId);
    }, [reportId]);

    useEffect(() => {
        let s_data = {total : 0, check : 0, Y : 0, Yed : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0};
        measureList.map(curr => {
            s_data.total = (s_data.total + curr.total);
            s_data.check = (s_data.check + curr.check);
            s_data.Y = (s_data.Y + curr.Y);
            s_data.Yed = (s_data.Yed + curr.Yed);
            s_data.N = (s_data.N + curr.N);
            s_data.P = (s_data.P + curr.P);
            s_data.NA = (s_data.NA + curr.NA);
            s_data.total_score = (s_data.total_score + curr.total_score);
            s_data.eval_score = (s_data.eval_score + curr.eval_score);
            return s_data;
        });
        s_data.level = (s_data.eval_score / s_data.total_score) * 100;
        setSumData(s_data);
      }, [measureList]);

      useEffect(() => {
        let s_data = [];
        assetList.map(curr => {
            s_data.push({'asset_cd': curr.code, 'sum': curr.Y });
            return s_data;
        });
        setAssetSum(s_data);
    
      }, [assetList]);

    // 레포트 조회
    const findReportList = (reportId) => {
        if(reportId) {
            //통계 조회
            axios.get(getFindVulnerablityStatistics(reportId, reportType))
                .then((response) => {
                    setItemList(response.data.statistic_root_U);
                    setMeasureList(response.data.statistic_measure_U);
                    setAssetList(response.data.statistic_asset_U);
                    setCompareList(response.data.list_measure_compare);
                    setAssetListU(response.data.asset_list_U);
                })
                .catch((error) => {
                    console.log("ImplementReport.js --- 92 error");
                    console.dir(error);
                })
                .finally(() => {
                    setSpinflag(false);
                });
        }
    }

    // 닫기
    const onClickCloseHandler = () => {
        window.close();
    }

    // 탭클릭
    const onChangeTabHandler = (key) => {
        //console.log(key);
        setTabId(key);
    };

    //PDF다운로드
    // const pdfDownload = () => {

    //     const report = document.getElementById('report');
    //     const data = document.getElementById('divTabs' + tabId);
    //     const div_height = data.style.height;
    //     data.style.height = (data.scrollHeight) + 'px';
    //     html2canvas(report).then((canvas) => {
    //     const margin = 6; // 출력 페이지 여백설정
    //     const imgWidth = 198;  // 208
    //     const pageHeight = 295;
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //     let heightLeft = imgHeight;
    //     let position = margin;
    //     heightLeft -= pageHeight;
    //     const doc = new jsPDF('p', 'mm', 'a4');
    //     doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
    //     while (heightLeft >= 0) {
    //         position = heightLeft - imgHeight;
    //         doc.addPage();
    //         doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
    //         heightLeft -= pageHeight;
    //     }
    //     doc.save('ImplementReport_'+reportId+'.pdf');
    //     });
    //     //높이 재조정
    //     data.style.height = div_height;
    // };
    
    const pdfDownLoadReport = (event) =>{
        setSpinflagMain(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다...");
        let titleName="보고서 생성";
        
        const buttonType = event.currentTarget.textContent;

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("followup_md", reportId)).then((response) => {
                setMarkdownContent(response.data);
                setMarkdownVisible(true);
                setSpinflagMain(false);
            }).catch((error) => {
                Modal.error({title:titleName,content:"Markdown 생성 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });  
        }else{
            axios.get(getPdfDownload("followup", reportId)).then((response) => {
                if(response.data.status_url){
                    DownloadUrl(response.data.status_url,
                        () => setSpinflagMain(false), // onSuccess
                        (errorMessage) => {
                            Modal.error({title:titleName,content:errorMessage, okText:"Close"});
                            setSpinflagMain(false);
                        }
                    );
                }else{
                    Modal.error({title:titleName,content:"PDF 다운로드 리턴 에러가 발생하였습니다.", okText:"Close"});
                    setSpinflagMain(false);
                }
            }).catch((error) => {
                Modal.error({title:titleName,content:"PDF 다운로드 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });  
        } 
    };

    const tabItems = [
        {
            label: '요약 및 그래프',
            key: '1',
            children: <Summary assetType={assetType} measureList={measureList} assetList={assetList} sumData={sumData} assetList_u={assetList_u} spinflag={spinflag} />,
        },
        {
            label: '항목별 통계',
            key: '2',
            children: <Item itemList={itemList} sumData={sumData} assetSum={assetSum} assetList_u={assetList_u} />,
        },
        {
            label: '위험 평가',
            key: '3',
            children: <Compare compareList={compareList} assetList_u={assetList_u} rowKey="measure_type" />,
        },
    ];    
    // eslint-disable-next-line
    return (
        <Spin size={"large"}  tip={loadMessage} spinning={spinflagMain}>
        <Layout id="report" style={{overflow: 'hidden'}}>
            <div className='popup_header'>
                <div className='popup_title'>
                    이행진단 : 통계
                </div>
            </div>
            <div className="popup_button_report" style={{top:'10px'}}>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'Markdown'}
                </Button>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'보고서'}
                </Button>
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}
                    data-html2canvas-ignore="true"
                >
                    {'닫기'}
                </Button>
            </div>
            <div className="section" id="reportHeader">
                <ReportHeader reportId={reportId} reportInfo={reportInfo} setReportInfo={setReportInfo}/>
            </div>
            <div className="section" style={{borderTop: '0'}}>
                 <Content style={{ backgroundColor: '#f5f5f5'}}>
                    <Tabs defaultActiveKey="1" type={'card'} items={tabItems} onChange={onChangeTabHandler} />
                </Content>        
            </div>
        </Layout>
        <MarkdownViewer 
            visible={markdownVisible}
            onClose={() => setMarkdownVisible(false)}
            markdownContent={markdownContent}
            reportId={reportId}
            reportName={reportName}
        />
        </Spin>
    );
}

export default ImplementReport;